export default __webpack_public_path__ + "static/media/2324 spice rack top.1a3635d2.png";